import create from "zustand";
import { initialState, StoreState } from "./state";
import { logger } from "./middleware";

type Store = StoreState;

export const useSeatedReservationStore = create<Store>(
  logger(
    (set, get) => ({
      ...initialState,
    }),
    "seated-reservation-store"
  )
);

export const getState = useSeatedReservationStore.getState;
export const setState = useSeatedReservationStore.setState;

export * from "./state";
